import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const postDeletePatients = async ({ patientsList }) => {
  const token = localStorage.getItem("token");

  const payload = {
    patients: patientsList,
  };

  await axios.post(`${__API_URL__}/api/patient/patient/delete_patients/`, payload, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });
};

const useDeletePatients = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postDeletePatients,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["patients"] });
    },
  });
};

export default useDeletePatients;
